import { render, staticRenderFns } from "./DisagreeAppointingGuardianOfChild.vue?vue&type=template&id=0cc925b9"
import script from "./DisagreeAppointingGuardianOfChild.vue?vue&type=script&lang=ts"
export * from "./DisagreeAppointingGuardianOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports